/**
 * Libellés courts des dossiers d'une conversation, dans le composeur.
 *
 * WHY : des dossiers d'un même client ou d'un même lot portent souvent le même
 * début de titre (« [VERIF-2026-10-09] Martin c. Durand — bail », « … — appel »).
 * Coupés à la même largeur, ils devenaient identiques à l'œil (retour du
 * 2026-11-02). On retire donc le début COMMUN à tous les titres affichés, pour
 * montrer ce qui les distingue ; le titre complet reste au survol.
 *
 * Le début commun n'est retiré qu'à une frontière de mot, et seulement si chaque
 * libellé restant garde au moins `MIN_LABEL_LENGTH` caractères : un libellé
 * réduit à « a » ne distinguerait plus rien. Un seul dossier garde son titre.
 */
const MIN_LABEL_LENGTH = 3;

/** Séparateurs qu'un libellé raccourci ne doit pas garder en tête. */
const LEADING_SEPARATORS = /^[\s\-–—:·,/]+/u;

export function distinctiveCaseLabels(titles: readonly string[]): string[] {
  if (titles.length < 2) return [...titles];
  let prefix = titles[0] ?? '';
  for (const title of titles) {
    while (prefix && !title.startsWith(prefix)) prefix = prefix.slice(0, -1);
  }
  // Frontière de mot : on ne coupe jamais au milieu d'un mot commun aux titres.
  const boundary = Math.max(prefix.lastIndexOf(' '), prefix.lastIndexOf(']'));
  if (boundary <= 0) return [...titles];
  const labels = titles.map((title) => title.slice(boundary + 1).replace(LEADING_SEPARATORS, '').trim());
  return labels.every((label) => label.length >= MIN_LABEL_LENGTH) ? labels : [...titles];
}
